import React, {useRef} from "react";
import {Button} from "@material-ui/core";

export default function ({deviceCode, ...props}){
    const link = useRef()

    return <>
        <a
            href={`https://sonasafe.zendesk.com/agent/search/1?q=fieldvalue:${deviceCode}`}
            ref={link}
            target="new-window"
            style={{
                position:"fixed",
                top: "-200vw",
                left: "-200vw",
                visibility: "hidden"
            }}
        />
        <Button variant="text" color="primary" onClick={() => link.current.click()} {...props} />
    </>
}
